// @ts-strict
const COMPONENT_ID = 'lm-report-field-picker';

const Service = {
  SelectReportDialog: {
    dialogId: 'SelectReportDialog',
    automationid: COMPONENT_ID + '-select-report-dialog',

    title: 'FindYourReport',
  },
  UnsavedReportDialog: {
    dialogId: 'UnsavedReportDialog',
    automationid: COMPONENT_ID + '-unsaved-report-dialog',

    title: 'ReportFieldPickerUnsavedReportDialogTitle',
    message: 'ReportFieldPickerUnsavedReportDialogMessage',
  },
};

const Drawer = {
  title: 'SelectedReportFields',
  Button: {
    addToExistingReportId: COMPONENT_ID + '-drawer-add-to-existing-report-button',
    createNewReportId: COMPONENT_ID + '-drawer-create-new-report-button',
    collapseId: COMPONENT_ID + '-drawer-collapse',
    expandId: COMPONENT_ID + '-drawer-expand',
    cancelId: COMPONENT_ID + '-drawer-cancel-report',

    addToExistingReportLabel: 'ReportFieldPickerDrawerButtonAddToExistingReport',
    addToExistingReportTitle: 'ReportFieldPickerDrawerButtonAddToExistingReportTitle',
    createNewReportLabel: 'ReportFieldPickerDrawerButtonCreateNewReport',
    createNewReportTitle: 'ReportFieldPickerDrawerButtonCreateNewReportTitle',
    collapse: 'ReportFieldPickerDrawerCollapse',
    expand: 'ReportFieldPickerDrawerExpand',
    cancel: 'ReportFieldPickerDrawerCancel',
  },
};

const Button = {
  Icon: {
    automationId: COMPONENT_ID + '-button-icon',
    addTitle: 'ReportFieldPickerButtonAddTitle',
    addedTitle: 'ReportFieldPickerButtonAddedTitle'
  },
};

const Viewer = {
  Tag: {
    automationId: COMPONENT_ID + '-viewer-tag-item',
  },
};

export const ReportFieldPickerConstants = { Service, Button, Drawer, Viewer };
